function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#29B587",
  d: "M962 18v9h-90v-9z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2BA691",
  d: "M873 18v9h-29v-9z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A8F9D",
  d: "M835 9v9h-92V9zm10 9v9h-81v-9zm-238 9v9H471v-9z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#285D99",
  d: "M963 0v9h-58V0zM764 18v9H644v-9zm-293 9v9H299v-9z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#2B4697",
  d: "M644 18v9H485v-9z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#2E3195",
  d: "M228 27v9h-43v-9z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#512D93",
  d: "M748 36v9h-23v-9z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#6C2E92",
  d: "M450 9v9h-94V9zm-63 9v9H218v-9z"
});

function SvgDividerBlockRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 963 56",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, /*#__PURE__*/React.createElement("path", {
    d: "M839.5 11.5v8h116v-8h-116zm-67 18v8h187v-8h-187z",
    stroke: "#29B587",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.5 11.5v8h9v-8h-9zm-59 18h-169v8h169v-8z",
    stroke: "#2BA691",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.5 11.5v8h106v-8h-106zm239 27v8h39v-8h-39z",
    stroke: "#285D99",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.5 2.5v8h58v-8h-58zm-260 9v8h49v-8h-49zm-360 18v8h72v-8h-72zm599 9v8h49v-8h-49z",
    stroke: "#2B4697",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.5 2.5v8h24v-8h-24zm-336 9v8h99v-8h-99zm-32 9v8h30v-8h-30zm293 18v8h77v-8h-77zm127 9v8h36v-8h-36z",
    stroke: "#2E3195",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.5 2.5v8h35v-8h-35zm-337 9v8h35v-8h-35zm-64 9v8h68v-8h-68zm-366 9v8h164v-8h-164zm842 18v8h11v-8h-11z",
    stroke: "#512D93",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 29.5v8h14v-8H.5zm681 9v8h38v-8h-38zm140 9v8h35v-8h-35z",
    stroke: "#6C2E92",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.5 2.5v8h38v-8h-38zm-451 9v8h60v-8h-60zm-212 9v8h132v-8h-132zm489 18v8h111v-8h-111zm226 9v8h25v-8h-25z",
    stroke: "#7A3390",
    style: {
      mixBlendMode: "screen"
    }
  })));
}

export default "data:image/svg+xml;base64,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";
export { SvgDividerBlockRight as ReactComponent };